import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {CirclePersonIcon} from 'shells/icon/svg/circle-person-icon';
// @ts-expect-error - imported from .js/.jsx file
import {LockedIcon} from 'shells/icon/svg/locked-icon';
// @ts-expect-error - imported from .js/.jsx file
import {SiteGlobeIcon} from 'shells/icon/svg/site-globe-icon';

import type {ShareType} from '../../../filtering/share-selection';

import type {NavItemObj} from '../types';

import {Count} from './count';

import styles from './nav-item.module.css';

type Props = {
    navItem: NavItemObj;
};

export function TwoLineNavItemContent(props: Props) {
    const {shareText, shareIcon} = getShareTextAndIcon(props.navItem.sharedWith);

    return (
        <div className='flex flex-dir-col full-width'>
            <span data-tip={props.navItem.name} className={styles['nav-item-name--two-line']}>
                {props.navItem.name}
            </span>
            <div className={styles['nav-item-second-line']}>
                <span className='flex align-center gap-4'>
                    {shareIcon}
                    {shareText}
                </span>
                <Count navItem={props.navItem} />
            </div>
        </div>
    );
}

function getShareTextAndIcon(shareType: ShareType): {
    shareText: string;
    shareIcon: React.ReactNode;
} {
    switch (shareType) {
        case 'everyone':
            return {
                shareText: 'Everyone',
                shareIcon: <SiteGlobeIcon wrapWithDiv={false} size='9' />,
            };
        case 'individuals':
            return {
                shareText: 'Specific users',
                shareIcon: <CirclePersonIcon wrapWithDiv={false} size='9' />,
            };
        case 'nobody':
        default:
            return {
                shareText: 'Private',
                shareIcon: <LockedIcon wrapWithDiv={false} size='9' />,
            };
    }
}
